'use client';
import { CommonContext } from '@/shared/components';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useContext } from 'react';

export default function ManagementNavbar() {
  const pathname = usePathname();

  const isUsersActive = pathname === '/management/users';
  const isTenantsActive = pathname === '/management/tenants';

  const { disableNavigation, setModalWarningOpen } = useContext(CommonContext);

  return (
    <div className="w-[100px]">
      <div className="flex flex-col items-center gap-[35px]">
        <div className="flex items-center justify-center w-full h-[50px] border-b border-b-[1px] border-b-[#e1e1e1] border-solid">
          <p className="font-bold">Mgmt</p>
        </div>
        <div className="flex flex-col items-center gap-[25px]">
          <Link href="/management/users" className="lg:w-[90px]">
            <div className="flex justify-center">
              <div
                className={`flex flex-col items-center w-[70px] h-[70px] justify-center ${isUsersActive ? 'border border-[1px] border-[#bfdbff] border-solid rounded-[10px] bg-[#eff6ff]' : ''}`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 24 24"
                  fill="#000000"
                >
                  <g
                    fill="none"
                    stroke={isUsersActive ? '#1447e6' : '#000000'}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87m-3-12a4 4 0 0 1 0 7.75" />
                  </g>
                </svg>
                <p
                  className={`font-medium ${isUsersActive ? 'text-[#1447e6]' : 'text-[#000000]'}`}
                >
                  Users
                </p>
              </div>
            </div>
          </Link>
          <button
            type="button"
            onClick={e => {
              if (disableNavigation) {
                e.preventDefault();
                setModalWarningOpen(true);
              }
            }}
          >
            <Link
              href={disableNavigation ? '#' : '/management/tenants'}
              className="lg:w-[90px]"
            >
              <div className="flex justify-center ">
                <div
                  className={`flex flex-col items-center w-[70px] h-[70px] justify-center ${isTenantsActive ? 'border border-[1px] border-[#bfdbff] border-solid rounded-[10px] bg-[#eff6ff]' : ''}`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 24 24"
                    fill="#000000"
                  >
                    <g
                      fill="none"
                      stroke={isTenantsActive ? '#1447e6' : '#000000'}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <rect width="16" height="20" x="4" y="2" rx="2" ry="2" />
                      <path d="M9 22v-4h6v4M8 6h.01M16 6h.01M12 6h.01M12 10h.01M12 14h.01M16 10h.01M16 14h.01M8 10h.01M8 14h.01" />
                    </g>
                  </svg>
                  <p
                    className={`font-medium ${isTenantsActive ? 'text-[#1447e6]' : 'text-[#000000]'}`}
                  >
                    Tenants
                  </p>
                </div>
              </div>
            </Link>
          </button>
        </div>
      </div>
    </div>
  );
}
